import { render, staticRenderFns } from "./CreateMarkModal.vue?vue&type=template&id=773041bc&scoped=true&"
import script from "./CreateMarkModal.vue?vue&type=script&lang=js&"
export * from "./CreateMarkModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMarkModal.vue?vue&type=style&index=0&id=773041bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773041bc",
  null
  
)

export default component.exports